const formatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  currencyDisplay: 'symbol',
  currencySign: 'standard',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  minimumIntegerDigits: 1,
});

const formatterMonetaryValue = (value: number | string | null): string => {
  if (!value) return formatter.format(0);

  let numericValue: number;

  if (typeof value === 'string') {
    numericValue = parseFloat(value) || 0;
  } else {
    numericValue = value;
  }

  let formatted = formatter.format(numericValue);

  if (formatted.startsWith('-R$')) {
    formatted = formatted.replace('-R$', 'R$ -');
  }

  return formatted;
};

export default formatterMonetaryValue;

export const formatCurrency = (value: string) => {
  const isNegative = value.startsWith('-');
  const numericPart = value.replace(/\D/g, '');
  const floatValue = parseInt(numericPart, 10) / 100;

  const formattedNumber = floatValue.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return isNegative ? `-${formattedNumber}` : formattedNumber;
};

export function formatCPFAndCNPJ(value: string | number | null | undefined): string {
  if (!value) return '---';

  const digits = String(value).replace(/\D/g, '');

  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  if (digits.length === 14) {
    return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  return '---';
}

export const isSupplierCodeValid = (code: string) => {
  const digits = code.replace(/\D/g, '');
  return digits.length === 0 || digits.length === 11 || digits.length === 14;
};

export function formatHandleCPFAndCNPJ(value: string): string {
  if (!value) return '';

  const digits = value.replace(/\D/g, '');

  if (digits.length <= 11) {
    return digits
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
  }

  if (digits.length <= 14) {
    return digits
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  return digits.slice(0, 14);
}

export function cpfOrCpnjFromBack(value: string) {
  if (!value) return '';

  return value.replace(/\D/g, '');
}

export function formatDotToComma(value: number | string | null | undefined) {
  if (value === null || value === undefined || value === '') {
    return '---';
  }

  return String(value).replace('.', ',');
}
